<!-- Hero -->
<div class="bid-hero">
  <button mat-icon-button class="back-btn" (click)="goBack()" matTooltip="Back to home">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <div class="hero-inner">
    <div class="hero-eyebrow">Project Bidding</div>
    <h1 class="hero-title">Get Competitive Bids<br>on Your Project</h1>
    <p class="hero-sub">Request quotes from multiple contractors, track every conversation, and award the job — all in one place.</p>
    <button class="hero-cta" (click)="getStarted()">Start Tracking Bids Free</button>
  </div>
</div>

<!-- Body -->
<div class="bid-body">

  <!-- How it works -->
  <section class="bid-section">
    <h2 class="section-heading">How It Works</h2>
    <p class="section-sub">Four simple steps from request to contract award.</p>
    <div class="steps-grid">
      <div class="step-card" *ngFor="let step of steps; let i = index">
        <div class="step-num">{{ i + 1 }}</div>
        <div class="step-icon-wrap">
          <mat-icon class="step-icon">{{ step.icon }}</mat-icon>
        </div>
        <h3 class="step-title">{{ step.title }}</h3>
        <p class="step-desc">{{ step.description }}</p>
      </div>
    </div>
  </section>

  <!-- Bid statuses -->
  <section class="bid-section">
    <h2 class="section-heading">Bid Lifecycle</h2>
    <p class="section-sub">Every bid progresses through clear, trackable stages so you always know what's next.</p>
    <div class="status-timeline">
      <div class="status-card" *ngFor="let s of statuses">
        <div class="status-dot" [style.background]="s.color">
          <mat-icon class="status-icon">{{ s.icon }}</mat-icon>
        </div>
        <div class="status-info">
          <span class="status-label" [style.color]="s.color">{{ s.label }}</span>
          <p class="status-desc">{{ s.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Contacts feature callout -->
  <section class="bid-section contacts-callout">
    <div class="callout-icon-wrap">
      <mat-icon class="callout-icon">contacts</mat-icon>
    </div>
    <div class="callout-body">
      <h2 class="callout-heading">Multi-Contact Tracking Per Bid</h2>
      <p class="callout-text">Large contractors have multiple people involved in the quoting process — estimators, project managers, sales reps. With Already Done, you can attach unlimited contacts to any bid so every conversation, email, and phone number is in one place.</p>
      <ul class="callout-list">
        <li><mat-icon>check</mat-icon> Add name, title, email &amp; phone for each contact</li>
        <li><mat-icon>check</mat-icon> Edit or remove contacts at any time</li>
        <li><mat-icon>check</mat-icon> Contacts travel with the bid — no separate address book needed</li>
      </ul>
    </div>
  </section>

  <!-- FAQ -->
  <section class="bid-section">
    <h2 class="section-heading">Frequently Asked Questions</h2>
    <div class="faq-list">
      <div class="faq-item" *ngFor="let faq of faqs; let i = index"
           [class.faq-open]="openFaq === i">
        <div class="faq-question" (click)="toggleFaq(i)">
          <span>{{ faq.q }}</span>
          <mat-icon>{{ openFaq === i ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <div class="faq-answer" *ngIf="openFaq === i">{{ faq.a }}</div>
      </div>
    </div>
  </section>

  <!-- Bottom CTA -->
  <section class="bottom-cta">
    <h2>Ready to take control of your bids?</h2>
    <p>Sign up free — no credit card required.</p>
    <button class="hero-cta bottom-cta-btn" (click)="getStarted()">Get Started Free</button>
  </section>

</div>
